import { useRef as e, useEffect as n } from "react";
export default function (t, r, i, o) {
  void 0 === i && (i = global), void 0 === o && (o = {});
  var c = e(),
    u = o.capture,
    a = o.passive,
    v = o.once;
  n(function () {
    c.current = r;
  }, [r]), n(function () {
    if (i && i.addEventListener) {
      var e = function e(_e) {
          return c.current(_e);
        },
        n = {
          capture: u,
          passive: a,
          once: v
        };
      return i.addEventListener(t, e, n), function () {
        i.removeEventListener(t, e, n);
      };
    }
  }, [t, i, u, a, v]);
}